import { render, staticRenderFns } from "./TutorialTooltip.vue?vue&type=template&id=21fc3bf0"
import script from "./TutorialTooltip.vue?vue&type=script&lang=js"
export * from "./TutorialTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports